/* ==========================================================================
   Femme Aura — motion layer

   Deliberately small. Two jobs, both cheap, both progressive enhancements:

   1. Publish the header's height as --fa-header-h, so the homepage hero can
      be pulled up underneath a transparent header. If this never runs the
      variable stays 0px and the header simply sits above the hero — the
      ordinary layout, not a broken one.
   2. Toggle a scrolled state on the header so it becomes solid once the
      page moves under it.

   What is NOT here, on purpose:
   - Pointer-tracked 3D card tilt. Rotating a card under the cursor moves it
     out from beneath the pointer and fires pointerleave/enter repeatedly;
     it read as jitter and made cards awkward to click. The hover lift is
     pure CSS now.
   - Scroll reveal. Dawn ships its own (.scroll-trigger + animations.js,
     behind the "Reveal sections on scroll" setting). A second opacity:0
     layer over the same elements only adds ways for content to get stuck
     invisible.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  var header = null;
  var frame = null;

  function findHeader() {
    header = document.querySelector('.header-wrapper');
    return header;
  }

  /* --- 1 · header height ------------------------------------------------ */

  function measure() {
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) root.style.setProperty('--fa-header-h', h + 'px');
  }

  /* --- 2 · scrolled state ----------------------------------------------- */

  function update() {
    frame = null;
    if (header) header.classList.toggle('fa-scrolled', window.scrollY > 40);
  }

  function onScroll() {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  }

  /* --- boot -------------------------------------------------------------- */

  function init() {
    if (!findHeader()) return;
    measure();
    update();
  }

  init();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }

  window.addEventListener('load', measure);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure, { passive: true });

  // The announcement bar rotates and the header can be re-rendered by the
  // theme editor; both change the height this depends on.
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(measure);
    var start = function () {
      if (header) ro.observe(header);
    };
    if (header) start();
    else document.addEventListener('DOMContentLoaded', function () {
      findHeader();
      start();
    });
  }

  document.addEventListener('shopify:section:load', function () {
    findHeader();
    measure();
    update();
  });
})();
